// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3fdfbac5","239":"e5291b79","455":"da83f317","488":"0760efba"}[chunkId] + ".chunk.js";
};